import React from "react";
import { X } from "lucide-react";
import { formatPrice } from "../../lib/matrix";

export default function CostLine({ line, symbol, onChange, onRemove, warning }) {
  const priced = line.unit !== null && line.unit !== undefined;
  return (
    <li className={`cost-line ${line.qty > 0 ? "has-seats" : ""} ${warning ? "warn" : ""}`} data-testid={`cost-line-${line.key}`}>
      <div className="cost-name">
        <span className="name" title={line.name}>
          {line.name}
        </span>
        <span className="cost-sub">
          {line.kind === "suite" && <span className="mini-chip">suite add-on</span>}
          {line.kind === "addon" && <span className="mini-chip">add-on</span>}
          {priced ? (
            <span className={`unit ${line.estimated ? "est" : ""}`}>{formatPrice(line.unit, symbol, line.estimated)} / user / mo</span>
          ) : (
            <span className="unit missing">{line.priceLabel || (line.missing ? "not in dataset" : "no list price")}</span>
          )}
        </span>
      </div>
      <input
        type="number"
        inputMode="numeric"
        min={0}
        max={1000000}
        step={1}
        className="cost-input"
        value={line.qty || ""}
        placeholder="0"
        onChange={(e) => onChange(Math.max(0, parseInt(e.target.value || "0", 10) || 0))}
        onFocus={(e) => e.target.select()}
        aria-label={`${line.name} seats`}
        data-testid={`cost-seats-${line.key}`}
      />
      <div className="cost-amount mono" data-testid={`cost-monthly-${line.key}`}>
        {line.monthly === null || line.monthly === undefined ? "\u2014" : formatPrice(line.monthly, symbol, line.estimated)}
      </div>
      <div className="cost-amount mono annual" data-testid={`cost-annual-${line.key}`}>
        {line.annual === null || line.annual === undefined ? "\u2014" : formatPrice(line.annual, symbol, line.estimated)}
      </div>
      {onRemove ? (
        <button type="button" className="pin-x" onClick={onRemove} aria-label={`Remove ${line.name}`} data-testid={`cost-remove-${line.key}`}>
          <X size={13} />
        </button>
      ) : (
        <span className="cost-remove-gap" />
      )}
    </li>
  );
}
